import { IonGrid } from "@ionic/react";
import { Map, Overlay, ZoomControl } from "pigeon-maps";
import { useState } from "react";

const MapComponent: React.FC = () => {
  const [currentPoint, setCurrentPoint] = useState({
    latitude: 12.814,
    longitude: 77.594566,
  });

  const records = [
    {
      lat: 12.8148914,
      long: 77.6932039,
      img: "../assets/brand/renon-battery.png",
    },
    // {
    //   lat: 12.91212,
    //   long: 77.39676,
    //   img: "../assets/brand/renon-battery.png",
    // },
    // {
    //   lat: 12.9312,
    //   long: 77.59676,
    //   img: "../assets/brand/renon-battery.png",
    // },
    // {
    //   lat: 12.95132,
    //   long: 77.7676,
    //   img: "../assets/brand/renon-battery.png",
    // },
  ];

  return (
    <IonGrid>
      <Map
        defaultCenter={[currentPoint.latitude, currentPoint.longitude]}
        defaultZoom={9}
        touchEvents={true}
      >
        <ZoomControl />
        {records.map((record, index) => {
          return (
            <Overlay key={index} anchor={[record.lat, record.long]}>
              <img src={record.img} height={48} width={48} alt="model" />
            </Overlay>
          );
        })}
      </Map>
    </IonGrid>
  );
};

export default MapComponent;
